// extracted by mini-css-extract-plugin
export default {"title":"Pricing_title__ImU-S","description":"Pricing_description__6ugwv","card":"Pricing_card__LEUGP","cardTitle":"Pricing_cardTitle__oWnJy"};